var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 1H21.6665C22.5506 1 23.3984 1.35119 24.0235 1.97631C24.6486 2.60143 24.9998 3.44928 24.9998 4.33333V7.36667C24.9999 8.66036 25.3012 9.93626 25.8798 11.0933L27.4532 14.24C28.0318 15.3971 28.3331 16.673 28.3332 17.9667V27.6667C28.3332 28.5507 27.982 29.3986 27.3569 30.0237C26.7317 30.6488 25.8839 31 24.9998 31H4.99984C4.11578 31 3.26794 30.6488 2.64281 30.0237C2.01769 29.3986 1.6665 28.5507 1.6665 27.6667V17.9667C1.66659 16.673 1.96788 15.3971 2.5465 14.24L4.99984 9.33333V4.33333C4.99984 3.44928 5.35103 2.60143 5.97615 1.97631C6.60127 1.35119 7.44912 1 8.33317 1V1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 24.3334C20.1743 24.3334 21.6667 22.841 21.6667 21.0001C21.6667 19.1591 20.1743 17.6667 18.3333 17.6667C16.4924 17.6667 15 19.1591 15 21.0001C15 22.841 16.4924 24.3334 18.3333 24.3334Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 31.0001C5.88405 31.0001 6.7319 30.6489 7.35702 30.0238C7.98214 29.3986 8.33333 28.5508 8.33333 27.6667V17.9667C8.33325 16.6731 8.03196 15.3972 7.45333 14.2401L5 9.33341M13.3333 7.66675H16.6667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.af627ba779d917874ce9ac4b32907800.svg";
export { ForwardRef as ReactComponent };